import React, {createContext, useContext} from 'react';
import {IntentModel} from '../../shared/customer';

const IntentModelContext = createContext<IntentModel | null>(null);

export const IntentModelProvider = ({
  children,
  intentModel,
}: React.PropsWithChildren<{intentModel: IntentModel}>) => {
  return (
    <IntentModelContext.Provider value={intentModel}>
      {children}
    </IntentModelContext.Provider>
  );
};

export const useIntentModelFromContext = () => {
  const intentModel = useContext(IntentModelContext);
  if (!intentModel) {
    throw new Error('IntentModelContext not found');
  }

  return intentModel;
};
